import styled from "styled-components"

import Count from "@irati/ui/src/Count"
import {minWidthMedia} from "@irati/ui/src/global/media"

export const Flex = styled.div`
margin-top: 30px;
display: flex;
justify-content: space-between;
`

export const StyledCount = styled(Count)`
margin-right: 10px;
`

export const DesktopNumberAndText = styled.div`
display: none;
${minWidthMedia.phoneLandscape`
  display: inline-block;
`}
`

export const MobileSignedUpAndRemaining = styled.div`
display: flex;
justify-content: space-between;
${minWidthMedia.phoneLandscape`
  display: none;
`}
`
